import React, { useState, useEffect } from 'react';
import Ticker, { FinancialTicker } from 'nice-react-ticker';
import { useApi } from "../../services/api";
import "../../../src/tickerComponent.css";

const TickerComponent = () => {
  const { apiFetch } = useApi();
  const [data, setData] = useState({});

  useEffect(() => {
    async function loadData() {
      try {

        const response = await apiFetch('/api/home/priceTicker');

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error('Error fetching data:', error);
        alert('Error in Prices data');
      }
    }

    loadData();
  }, []);
  const tickerData = Object.keys(data).map((key) => {
    return {
      id: key,
      symbol: key,
      lastPrice: data[key],
      change:true
    };
  });

  return (
    <div className='tickerclass'>
      
      <Ticker slideSpeed ={50} isNewsTicker={true} >
        {tickerData.map((ticker) => (
          <FinancialTicker
            key={ticker.id}
            {...ticker}
           
          />
        ))}
      </Ticker>
    </div>
  );
};

export default TickerComponent;